import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, NgModule, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Logo, MarqueeLogoModule } from '@commons/marquee-logo/marquee-logo.component';
import { TooltipModule } from '@commons/tooltip/tooltip.component';
import { BreakpointsService } from '@core/services/breakpoints/breakpoints.service';
import { environment } from '@environment';
import { CompaniesRoutingEnum } from '@features/companies/companies-routing.enum';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { CompanyLogo } from '@models/company/company';
import { CompanyWebservice } from '@webservices/company-api/company.webservice';
import { trackEventWithAtInternet } from '@wizbii/tracking';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Component({
  selector: 'app-home-b-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeBCompaniesComponent implements OnInit {
  readonly skltnLogo = {
    'border-radius': '1.25rem',
    'background-color': 'white',
    'background-image': 'linear-gradient(90deg,rgba(245,248,253,0),rgba(245,248,253,.6),rgba(245,248,253,0))',
    height: '6.25rem',
    width: '6.25rem',
  };

  logos$!: Observable<Logo[]>;

  private readonly imageBaseUrl = `${environment.api.googleStorage}/${environment.wizbiiFiles}`;

  get isMobile$(): Observable<boolean> {
    return this.breakpointService.isMobile$;
  }

  FeaturesRoutingEnum = FeaturesRoutingEnum;
  CompaniesRoutingEnum = CompaniesRoutingEnum;
  trackEvent = trackEventWithAtInternet;

  constructor(
    private readonly breakpointService: BreakpointsService,
    private readonly companyWebservice: CompanyWebservice
  ) {}

  ngOnInit(): void {
    this.logos$ = this.companyWebservice.getLogos().pipe(
      map((companyLogos: CompanyLogo[]) => {
        return companyLogos.map((companyLogo: CompanyLogo) => ({
          src: `${this.imageBaseUrl}/${companyLogo.logo}`,
          width: 100,
          alt: `Logo de ${companyLogo.name}`,
        }));
      }),
      tap((logos: Logo[]) =>
        logos.splice(34, 1, {
          src: `${environment.wizbiiImages}/home/casa/casa_logo.png`,
          width: 250,
          alt: `Logo de casa`,
        })
      )
    );
  }
}

@NgModule({
  imports: [CommonModule, RouterModule, TooltipModule, MarqueeLogoModule, NgxSkeletonLoaderModule],
  declarations: [HomeBCompaniesComponent],
  exports: [HomeBCompaniesComponent],
})
export class HomeBCompaniesModule {}
